<template>
    <div class="page-container">
        <div class="chat-header">
            <span class="title">My Chat App</span>
        </div>
        <div>
            <label>Message</label><br />
            <textarea v-model="textarea" class="chatlist" readonly id="chatlist"></textarea>
            &ensp;
            <textarea v-model="userlist" class="userlist" readonly />
        </div>
        <div>
            <label>Your Message</label><br />
            <textarea v-model="message" class="mychat" @keydown.enter="sendEnterMessage" />
            <button type="button" class="btn btn-dark" @click="sendMessage">Submit</button>
        </div>
    </div>
</template>

<script setup>
    import { ref, onMounted, onBeforeUnmount, watch } from 'vue'
    import { useRoute } from 'vue-router'
    import { io } from 'socket.io-client'
    import { useStore } from 'vuex'

    const route = useRoute()

    // 채팅 관련 상태 변수들
    const textarea = ref('')
    const message = ref('')
    const userlist = ref([])
    const store = useStore()

    // 소켓 연결 URL (production / development 구분)
    const URL = process.env.NODE_ENV === 'production'
        ? process.env.VUE_APP_WSS_URL
        : 'http://localhost:3000'

    // 소켓 객체 (이것을 컴포넌트 내에서 관리)
    let socket = null

    // 소켓 연결 함수
    const connectSocket = () => {
        socket = io(URL, {
            withCredentials: true,
            transports: ['websocket'],
            path: '/ws/chat',
            autoConnect: false,
            secure: true,
            reconnection: false
        })

        // 소켓 연결 시 로그인 이벤트
        socket.on('connect', () => {

            const loginId = store.state.auth.user?.loginId || getAnonId()
            const email = store.state.auth.user?.email || "anon"
            socket.emit("login", { loginId, email })
            console.log('Connected ' + loginId)
        })

        // 사용자 입장
        socket.on('inChat', (data) => {
            textarea.value += `${data.loginId}가 입장하였습니다.\n`
        })

        // 사용자 퇴장
        socket.on('outChat', (data) => {
            textarea.value += `${data}가 퇴장하였습니다.\n`
        })

        // 사용자 리스트 업데이트
        socket.on('userlist', (data) => {
            userlist.value = data
        })

        // 채팅 메시지 수신
        socket.on('chat message', (data) => {
            textarea.value += `${data.id}: ${data.message}\n`
            scrollToElement()
        })

        // 연결 끊겼을 때
        socket.on('disconnect', () => {
            console.log('Disconnected')
        })

        // 연결 에러
        socket.on('connect_error', (err) => {
            console.error('socket error:', err.message)
        })

        // 연결 시작
        socket.connect()
    }

    // 소켓 연결 해제 함수
    const disconnectSocket = () => {
        if (socket) {
            socket.disconnect()
            socket = null
        }
    }

    // 메시지 전송 함수
    const sendMessage = () => {
        if (socket) {
            socket.emit('chat message', {
                message: message.value,
                id: store.state.auth.user?.loginId || getAnonId() // 여기에 실제 사용자 아이디 넣으면 됨
            })
        }

        message.value = ''
    }

    // 엔터로 메시지 전송
    const sendEnterMessage = (event) => {
        if (event.shiftKey) return
        if (event.keyCode === 13) {
            event.preventDefault()
            sendMessage()
        }
    }

    // 자동 스크롤
    const scrollToElement = () => {
        const el = document.getElementById('chatlist')
        if (el) el.scrollTop = el.scrollHeight
    }

    const getAnonId = () => {
        let anonId = localStorage.getItem('anonId')
        if (!anonId) {
            anonId = crypto.randomUUID()
            localStorage.setItem('anonId', anonId)
        }
        return anonId.slice(-5)
    }

    // 페이지 마운트 시 소켓 연결
    onMounted(() => {
        if (route.path === '/home') {
            connectSocket()
        }
    })

    // 페이지 이동 시 소켓 연결 상태 확인
    watch(
        () => route.path,
        (newPath) => {
            if (newPath === '/home') {
                //connectSocket()
            } else {
                disconnectSocket()
            }
        },
        { immediate: true }
    )

    // 컴포넌트 해제 시 소켓 해제
    onBeforeUnmount(() => {
        disconnectSocket()
    })
</script>

<style>
    .chatlist {
        width: 50%;
        height: 500px;
        padding: 10px;
        box-sizing: border-box;
        border: solid 2px #1E90FF;
        border-radius: 5px;
        font-size: 16px;
        resize: both;
    }

    .mychat {
        width: 50%;
        height: 80px;
        padding: 10px;
        box-sizing: border-box;
        border: solid 2px #000000;
        border-radius: 5px;
        font-size: 16px;
        resize: both;
    }

    .userlist {
        width: 15%;
        height: 80px;
        padding: 10px;
        box-sizing: border-box;
        border: solid 2px #1E90FF;
        border-radius: 5px;
        font-size: 16px;
        resize: both;
    }
</style>
